module.exports = __webpack_public_path__ + "img/seguridad_fondo.0fce8360.jpg";